module.exports = __webpack_public_path__ + "resources/img/logo_toast_gov_color_v2.7a31637047fc0f7f85f3ed41e6d75403.svg";